import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { DEVICE_SIZE, mq } from '../utils/mq';
import ArrowDown from '../icons/arrowDown';
import { useLinkComponent } from '../utils/component';
import Facebook from '../icons/facebook';
import Twitter from '../icons/twitter';

type ToolkitItemProps = {
  title: string;
};

const Toolkit = styled.div`
  bottom: 16px;
  display: none; /* Hide by default */
  flex-direction: column;
  gap: var(--spacer-s-fluid);
  opacity: 0;
  position: fixed;
  right: 16px;
  transition: opacity 0.3s;
  z-index: 1000;

  &.mod-show {
    opacity: 1;
  }

  ${mq.gte(
    DEVICE_SIZE.LARGE,
    css`
      display: flex; /* Show on larger screens */
      bottom: 12px;
      right: 24px;
    `,
  )}
`;

const Bubble = styled.div`
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 32px;
  padding: var(--spacer-xs);
  width: 32px;

  ${mq.gte(
    DEVICE_SIZE.LARGE,
    css`
      height: 52px;
      width: 52px;
    `,
  )}
`;

const FacebookWrapper = styled(Bubble)`
  background: #3b5998;
`;

const TwitterWrapper = styled(Bubble)`
  background: black;
`;

const BackTop = styled(Bubble)`
  background: #526c8a;
  transform: rotate(180deg);
  transition: background 0.3s;

  &:hover {
    background: #4a617c;
  }
`;

export const ToolkitItem = ({ title }: ToolkitItemProps) => {
  const ToolkitRef = useRef<HTMLDivElement>(null);
  const LinkComponent = useLinkComponent();
  const [currentUrl, setCurrentUrl] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      if (ToolkitRef.current) {
        if (window.scrollY > 300) {
          ToolkitRef?.current?.classList.add('mod-show');
        } else {
          ToolkitRef?.current?.classList.remove('mod-show');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    setCurrentUrl(window?.location?.href);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const backTop = () => {
    window.scroll({
      behavior: 'smooth',
      top: 0,
    });
  };

  return (
    <Toolkit ref={ToolkitRef}>
      <LinkComponent
        href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`}
        title="Partager sur Facebook"
        target="_blank"
        rel={['noreferrer']}
      >
        <FacebookWrapper>
          <Facebook width={24} height={24} color="var(--theme-palette-white)" />
        </FacebookWrapper>
      </LinkComponent>
      <LinkComponent
        href={`https://www.twitter.com/share?text=${title}&url=${currentUrl}`}
        title="Partager sur Twitter"
        target="_blank"
        rel={['noreferrer']}
      >
        <TwitterWrapper>
          <Twitter width={24} height={24} color="var(--theme-palette-white)" />
        </TwitterWrapper>
      </LinkComponent>
      <BackTop onClick={backTop}>
        <ArrowDown width={24} height={24} color="var(--theme-palette-white)" />
      </BackTop>
    </Toolkit>
  );
};
